export interface FlowchartPaper_Button_Interface {
    id:number,
    main_id:number,
    from_id:string,
    to_id:string,
    line: string,
    title: string,
    commectType: number,
    myIcon: string,
    myColor: string,
}

export function Empty_FlowchartPaper_Button_Interface():FlowchartPaper_Button_Interface{
    return{
        id:0,
        main_id:0,
        from_id:'',
        to_id:'',
        line: '',
        title: '',
        commectType: 0,
        myIcon: '',
        myColor: '',
    }
}